export default (
    window.__SETTINGS__ || {}
)
